import React, { Component } from "react";
import {
  loading,
  NavbarAdmin,
  GET,
  t, // นำเข้าฟังก์ชัน t
  fmtInt,
} from "../../components/CustomComponent.js";

// จานสีสำหรับ avatar ช่าง และกราฟวงกลมตามสถานที่
const AVATAR_BG = ["bg-primary", "bg-success", "bg-warning", "bg-secondary", "bg-info", "bg-dark"];
const LOCATION_COLORS = ["#0d6efd", "#198754", "#fd7e14", "#6c757d", "#6f42c1"];

// map สถานะใบสั่งงาน PM -> รูปแบบการแสดงผล (badge / ไอคอน / สีขอบ)
const STATUS_STYLE = {
  completed: { class: "bg-success-light text-success", icon: "", border: "#198754" },
  in_progress: { class: "bg-warning-light text-warning", icon: "", border: "#fd7e14" },
  scheduled: { class: "bg-primary-light text-primary", icon: "", border: "#0d6efd" },
  overdue: { class: "bg-danger-light text-danger", icon: "", border: "#dc3545" },
};

// map สถานะช่าง -> สีจุดแสดงสถานะ + badge
const TECH_STATUS = {
  working: { dot: "bg-success", tag: "bg-warning-light text-warning", label: "pm_task" },
  scheduled: { dot: "bg-primary", tag: "bg-primary-light text-primary", label: "scheduled" },
  overdue: { dot: "bg-danger", tag: "bg-danger-light text-danger", label: "overdue" },
  idle: { dot: "bg-secondary", tag: "bg-light text-secondary", label: "idle" },
};

export default class PMDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      lastUpdated: null,
      kpi: {
        pm_compliance: { value: 0, delta: 0, has_last_month: false },
        this_month: { completed: 0, total: 0 },
        in_progress: 0,
        overdue: 0,
        due_this_week: 0,
      },
      technicians: [],
      monthlyProgress: { month: null, weeks: [] },
      pmByLocation: { total: 0, data: [] },
      todaySchedule: [],
      activities: [],
    };
  }

  async componentDidMount() {
    await this.getData();
  }

  getData = async () => {
    loading(true);
    const result = await GET("admin/pm-dashboard");
    if (result?.status && result.data) {
      const d = result.data;
      this.setState({
        loaded: true,
        lastUpdated: d.last_updated || null,
        kpi: d.kpi || this.state.kpi,
        technicians: d.technicians || [],
        monthlyProgress: d.monthly_progress || { month: null, weeks: [] },
        pmByLocation: d.pm_by_location || { total: 0, data: [] },
        todaySchedule: d.today_schedule || [],
        activities: d.activities || [],
      });
    } else {
      this.setState({ loaded: true });
    }
    loading(false);
  };

  // เวลาแบบ relative ("x นาทีที่แล้ว")
  timeAgo = (iso) => {
    if (!iso) return "";
    const diffMs = Date.now() - new Date(iso).getTime();
    if (Number.isNaN(diffMs)) return "";
    const min = Math.floor(diffMs / 60000);
    if (min < 1) return t("just_now");
    if (min < 60) return `${min} ${t("minutes_ago")}`;
    const hr = Math.floor(min / 60);
    if (hr < 24) return `${hr} ${t("hours_ago")}`;
    const day = Math.floor(hr / 24);
    return `${day} ${t("days_ago")}`;
  };

  openWorkOrder = (woUid) => {
    if (!woUid) return;
    window.location.href = `/ad/work-orders?uid=${encodeURIComponent(woUid)}`;
  };

  // สร้าง conic-gradient จากสัดส่วน PM ตามสถานที่
  buildConicGradient = (data) => {
    if (!data.length) return "#e9ecef";
    let acc = 0;
    const stops = data.map((item, i) => {
      const color = LOCATION_COLORS[i % LOCATION_COLORS.length];
      const start = acc;
      acc += item.percent;
      return `${color} ${start}% ${acc}%`;
    });
    return `conic-gradient(${stops.join(", ")})`;
  };

  render() {
    const { kpi, technicians, monthlyProgress, pmByLocation, todaySchedule, activities, loaded } = this.state;

    const compliance = kpi.pm_compliance || { value: 0, delta: 0, has_last_month: false };
    const thisMonth = kpi.this_month || { completed: 0, total: 0 };
    const monthPct = thisMonth.total > 0 ? Math.round((thisMonth.completed / thisMonth.total) * 100) : 0;

    const weeks = monthlyProgress.weeks || [];
    const maxWeek = Math.max(1, ...weeks.map((w) => w.total || 0));
    const locData = pmByLocation.data || [];

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarAdmin />
        <div className="body p-4 mt-3">

          {/* Header Section */}
          <div className="d-flex flex-wrap justify-content-between align-items-end mb-4 gap-3">
            <div>
              <h3 className="fw-bold mb-1">{t("pm_dashboard")}</h3>
              <div className="text-secondary">{t("pm_dashboard_desc")}</div>
            </div>
            <div className="d-flex gap-3 align-items-center">
              <div className="text-secondary text-14">
                <span className="icon me-1">{""}</span>{" "}
                {this.state.lastUpdated ? this.timeAgo(this.state.lastUpdated) : t("last_updated_just_now")}
              </div>
              <button
                onClick={this.getData}
                className="btn btn-white bg-white border shadow-sm px-3 fw-bold rounded-3 text-dark d-flex align-items-center"
              >
                <span className="icon me-2 text-secondary">{""}</span> {t("refresh")}
              </button>
            </div>
          </div>

          {/* Top KPI Cards (5 Columns) */}
          <div className="row g-3 mb-4">

            <div className="col">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                <div className="d-flex justify-content-between mb-3">
                  <div className="text-secondary text-14 fw-bold">{t("pm_compliance")}</div>
                  <div className="wpx-30 hpx-30 rounded-circle bg-success-light text-success d-flex align-items-center justify-content-center icon">{""}</div>
                </div>
                <h2 className="fw-bold text-dark mb-1">{compliance.value}%</h2>
                <div className="text-12 text-secondary">
                  {compliance.has_last_month ? (
                    <>
                      <span className={`fw-bold me-1 ${compliance.delta >= 0 ? "text-success" : "text-danger"}`}>
                        <span className="icon text-10">{compliance.delta >= 0 ? "" : ""}</span>{" "}
                        {compliance.delta >= 0 ? "+" : ""}{compliance.delta}%
                      </span>
                      {t("vs_last_month")}
                    </>
                  ) : (
                    <span>{t("this_month")}</span>
                  )}
                </div>
              </div>
            </div>

            <div className="col">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                <div className="d-flex justify-content-between mb-2">
                  <div className="text-secondary text-14 fw-bold">{t("this_month")}</div>
                  <div className="wpx-30 hpx-30 rounded-circle bg-primary-light text-primary d-flex align-items-center justify-content-center icon">{""}</div>
                </div>
                <h2 className="fw-bold text-dark mb-2">
                  {fmtInt(thisMonth.completed)}<span className="text-20 text-secondary fw-normal">/{fmtInt(thisMonth.total)}</span>
                </h2>
                <div className="progress hpx-5">
                  <div className="progress-bar bg-primary" role="progressbar" style={{ width: `${monthPct}%` }}></div>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                <div className="d-flex justify-content-between mb-3">
                  <div className="text-secondary text-14 fw-bold">{t("in_progress")}</div>
                  <div className="wpx-30 hpx-30 rounded-circle bg-warning-light text-warning d-flex align-items-center justify-content-center icon">{""}</div>
                </div>
                <h2 className="fw-bold text-warning mb-1">{fmtInt(kpi.in_progress)}</h2>
                <div className="text-12 text-secondary">{t("active_inspections")}</div>
              </div>
            </div>

            <div className="col">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                <div className="d-flex justify-content-between mb-3">
                  <div className="text-secondary text-14 fw-bold">{t("overdue")}</div>
                  <div className="wpx-30 hpx-30 rounded-circle bg-danger-light text-danger d-flex align-items-center justify-content-center icon">{""}</div>
                </div>
                <h2 className="fw-bold text-danger mb-1">{fmtInt(kpi.overdue)}</h2>
                <div className="text-12 text-danger fw-bold"><span className="icon me-1 text-10">{""}</span> {t("action_needed")}</div>
              </div>
            </div>

            <div className="col">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                <div className="d-flex justify-content-between mb-3">
                  <div className="text-secondary text-14 fw-bold">{t("due_this_week")}</div>
                  <div className="wpx-30 hpx-30 rounded-circle bg-primary-light text-primary d-flex align-items-center justify-content-center icon">{""}</div>
                </div>
                <h2 className="fw-bold text-primary mb-1">{fmtInt(kpi.due_this_week)}</h2>
                <div className="text-12 text-secondary">{t("upcoming_tasks")}</div>
              </div>
            </div>

          </div>

          {/* Middle Row (3 Columns) */}
          <div className="row g-3 mb-4">

            {/* Technician Status */}
            <div className="col-lg-4">
              <div className="card border-0 rounded-4 shadow-sm p-4 h-100">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h6 className="fw-bold mb-0 d-flex align-items-center">
                    <span className="icon text-primary me-2 text-18">{""}</span> {t("technician_status")}
                  </h6>
                  <span className="badge bg-danger-light text-danger rounded-pill px-3">{t("live")}</span>
                </div>

                <div className="d-flex flex-column gap-4">
                  {technicians.length === 0 && (
                    <div className="text-center text-secondary text-14 py-4">{loaded ? t("no_technicians") : ""}</div>
                  )}
                  {technicians.map((tech, i) => {
                    const style = TECH_STATUS[tech.status] || TECH_STATUS.idle;
                    const isOnline = tech.status === "working" || tech.status === "scheduled";
                    return (
                      <div key={tech.uid || i} className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                          <div className="position-relative me-3">
                            <div className={`wpx-40 hpx-40 rounded-circle text-white d-flex align-items-center justify-content-center fw-bold text-14 ${AVATAR_BG[i % AVATAR_BG.length]}`}>
                              {tech.initials}
                            </div>
                            <div className={`position-absolute bottom-0 end-0 wpx-10 hpx-10 rounded-circle border border-2 border-white ${style.dot}`}></div>
                          </div>
                          <div>
                            <div className="fw-bold text-dark text-14 mb-1">
                              {tech.name} {isOnline && <span className="wpx-6 hpx-6 rounded-circle bg-success d-inline-block ms-1 align-middle"></span>}
                            </div>
                            <div className="text-secondary text-12">
                              {tech.task ? `${t("working_on")} ${tech.task}` : t("off_duty")}
                            </div>
                          </div>
                        </div>
                        <div className="text-end">
                          <span className={`badge rounded-pill fw-bold text-10 px-2 py-1 mb-1 d-block ${style.tag}`}>
                            {t(style.label)}
                          </span>
                          {tech.today_count > 0 && (
                            <div className="text-secondary text-10">{tech.today_count} {t("today")}</div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Monthly Progress */}
            <div className="col-lg-4">
              <div className="card border-0 rounded-4 shadow-sm p-4 h-100">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h6 className="fw-bold mb-0 d-flex align-items-center">
                    <span className="icon text-primary me-2 text-18">{""}</span> {t("monthly_progress")}
                  </h6>
                  <span className="text-secondary text-14">{monthlyProgress.month || ""}</span>
                </div>

                <div className="d-flex flex-column h-100 justify-content-end">
                  {weeks.length === 0 ? (
                    <div className="text-center text-secondary text-14 py-5">{loaded ? t("no_pm_data") : ""}</div>
                  ) : (
                    <>
                      <div className="d-flex align-items-end justify-content-around hpx-150 border-bottom border-start pb-2 ps-2 position-relative">
                        <div className="position-absolute top-0 start-0 translate-middle-x ms-2 d-flex flex-column justify-content-between h-100 text-secondary text-10">
                          <span>{maxWeek}</span><span>{Math.round(maxWeek * 0.5)}</span><span>0</span>
                        </div>
                        {weeks.map((w, i) => (
                          <div key={i} className="d-flex align-items-end gap-1 h-100">
                            <div className="bg-success rounded-top" style={{ width: "22px", height: `${Math.round(((w.completed || 0) / maxWeek) * 100)}%` }} title={`${w.completed}`}></div>
                            <div className="bg-primary-light rounded-top" style={{ width: "22px", height: `${Math.round(((w.total || 0) / maxWeek) * 100)}%` }} title={`${w.total}`}></div>
                          </div>
                        ))}
                      </div>
                      <div className="d-flex justify-content-around mt-2 text-secondary text-10">
                        {weeks.map((w, i) => (
                          <div key={i}>{t(`week_${w.week}`) !== `week_${w.week}` ? t(`week_${w.week}`) : `W${w.week}`}</div>
                        ))}
                      </div>
                      <div className="d-flex justify-content-center gap-3 mt-3 text-10 text-secondary">
                        <div className="d-flex align-items-center"><div className="wpx-15 hpx-8 bg-success rounded me-1"></div> {t("completed")}</div>
                        <div className="d-flex align-items-center"><div className="wpx-15 hpx-8 bg-primary-light rounded me-1"></div> {t("scheduled")}</div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* PM by Location */}
            <div className="col-lg-4">
              <div className="card border-0 rounded-4 shadow-sm p-4 h-100">
                <h6 className="fw-bold mb-4 d-flex align-items-center">
                  <span className="icon text-primary me-2 text-18">{""}</span> {t("pm_by_location")}
                </h6>
                <div className="d-flex flex-column align-items-center justify-content-center h-100">
                  {locData.length === 0 ? (
                    <div className="text-center text-secondary text-14 py-5">{loaded ? t("no_pm_data") : ""}</div>
                  ) : (
                    <>
                      <div
                        className="rounded-circle position-relative mb-4"
                        style={{ width: "200px", height: "200px", background: this.buildConicGradient(locData) }}
                      >
                        <div className="position-absolute top-50 start-50 translate-middle bg-white rounded-circle d-flex flex-column align-items-center justify-content-center" style={{ width: "130px", height: "130px" }}>
                          <div className="fw-bold text-dark text-20">{fmtInt(pmByLocation.total)}</div>
                          <div className="text-secondary text-10">{t("total")}</div>
                        </div>
                      </div>
                      <div className="d-flex flex-wrap justify-content-center gap-3 w-100 text-12 text-secondary">
                        {locData.map((loc, i) => (
                          <div key={i} className="d-flex align-items-center">
                            <div className="wpx-15 hpx-8 rounded me-2" style={{ backgroundColor: LOCATION_COLORS[i % LOCATION_COLORS.length] }}></div>
                            {loc.name || t("other")} ({loc.percent}%)
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

          </div>

          {/* Bottom Row (2 Columns) */}
          <div className="row g-3">

            {/* Today's PM Schedule */}
            <div className="col-lg-6">
              <div className="card border-0 rounded-4 shadow-sm p-4 h-100">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h6 className="fw-bold mb-0 d-flex align-items-center">
                    <span className="icon text-primary me-2 text-18">{""}</span> {t("todays_pm_schedule")}
                  </h6>
                  <span className="text-secondary text-14">{t("today")} · {todaySchedule.length}</span>
                </div>

                <div className="d-flex flex-column gap-3">
                  {todaySchedule.length === 0 && (
                    <div className="text-center text-secondary text-14 py-4">{loaded ? t("no_pm_scheduled_today") : ""}</div>
                  )}
                  {todaySchedule.map((item, idx) => {
                    const style = STATUS_STYLE[item.status] || STATUS_STYLE.scheduled;
                    return (
                      <div
                        key={item.wo_uid || idx}
                        onClick={() => this.openWorkOrder(item.wo_uid)}
                        className="d-flex bg-white border rounded-3 p-3 shadow-sm align-items-center pointer"
                        style={{ borderLeft: `5px solid ${style.border}`, cursor: "pointer" }}
                      >
                        <div className="fw-bold text-dark text-16 wpx-60 flex-shrink-0">{item.time}</div>
                        <div className="flex-grow-1 border-start ps-3 ms-2">
                          <div className="fw-bold text-dark text-14 mb-1">{item.title}</div>
                          <div className="text-secondary text-12">
                            {[item.location, item.technician].filter(Boolean).join(" | ")}
                          </div>
                        </div>
                        <div className={`badge rounded-pill fw-bold text-12 px-3 py-2 ${style.class}`}>
                          <span className="icon me-1">{style.icon}</span> {t(item.status)}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Live Activity Feed */}
            <div className="col-lg-6">
              <div className="card border-0 rounded-4 shadow-sm p-4 h-100">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h6 className="fw-bold mb-0 d-flex align-items-center">
                    <span className="icon text-primary me-2 text-18">{""}</span> {t("live_activity_feed")}
                  </h6>
                  <div className="d-flex align-items-center text-success text-12 fw-bold">
                    <span className="wpx-8 hpx-8 rounded-circle bg-success me-2"></span> {t("live")}
                  </div>
                </div>

                <div className="d-flex flex-column gap-3">
                  {activities.length === 0 && (
                    <div className="text-center text-secondary text-14 py-4">{loaded ? t("no_activity") : ""}</div>
                  )}
                  {activities.map((act, idx) => {
                    const style = STATUS_STYLE[act.type] || STATUS_STYLE.scheduled;
                    const actionKey = act.type === "completed" ? "completed_pm" : act.type === "in_progress" ? "started_pm" : "scheduled_pm";
                    return (
                      <div key={idx} className="d-flex bg-light rounded-3 p-3 align-items-center">
                        <div className={`wpx-35 hpx-35 rounded-circle d-flex align-items-center justify-content-center icon text-14 flex-shrink-0 me-3 ${style.class}`}>
                          {style.icon}
                        </div>
                        <div className="flex-grow-1">
                          <div className="text-dark text-14 mb-1">
                            <span>
                              <strong>{act.technician || act.wo_number || "-"}</strong> {t(actionKey)} {act.asset}
                            </span>
                          </div>
                          {act.time && <div className="text-secondary text-12">{this.timeAgo(act.time)}</div>}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    );
  }
}
